import { ContentModel } from '@repo/shared';
import { z } from 'zod';

export const createExtractStructureWithDatasetSchema = z.object({
  datasetId: z.string(),
  models: z.array(z.string()).min(1),
});

export type CreateExtractStructureWithDatasetSchema = z.infer<
  typeof createExtractStructureWithDatasetSchema
>;

export const createExtractStructureWithFileSchema = z.object({
  files: z.array(z.instanceof(File)),
  models: z.array(z.string()).min(1),
  contentModel: z.enum(
    Object.values(ContentModel) as [string, ...Array<string>]
  ),
});

export type CreateExtractStructureWithFileSchema = z.infer<
  typeof createExtractStructureWithFileSchema
>;
